import {Modal as AntdModal} from "antd";
import {useModal} from "../context/ModalContext";
import {useEffect, useState} from "react";

export default function Modal()
{
    const {modal, closeModal} = useModal();
    const [reRender, setReRender] = useState(false)
    const [render, setRender] = useState(false)

    // modal yeniden acildiginda component guncellenmiyor.
    // render ile tekrar renderlanmaya zorlaniyor.
    useEffect(() => {
        if(modal.open)
        {
            setReRender(true)
            setRender(false)
        }
    }, [modal.open])

    useEffect(() => {
        if(reRender)
        {
            setTimeout(() => {
                setRender(true)
                setReRender(false)
            }, 100)
        }
    },[reRender])

    return (
        <div>
            <AntdModal
                style={{zIndex: 999999}}
                width={modal?.style?.width || window.innerWidth*0.6}
                visible={modal.open}
                title={modal.title}
                closable={modal.closable}
                onCancel={modal.closable && closeModal}
                onOk={false}
                footer={false}
            >
                {
                    render && modal.component
                }
            </AntdModal>
            <AntdModal
                style={{marginTop: 24, zIndex: 9999}}
                width={window.innerWidth*0.5}
                visible={modal.modal2.open}
                title={modal.modal2.title}
                closable={modal.modal2.closable}
                onCancel={modal.modal2.closable && closeModal}
                onOk={false}
                footer={false}
            >
                {
                    render && modal.modal2.component
                }
            </AntdModal>
        </div>
    )
}
